/**
 * Prop Studio — a BlenderKit asset id out of whatever was pasted.
 *
 * The asset-id box takes the id itself or anything that carries it: the
 * asset's gallery page (https://www.blenderkit.com/asset-gallery-detail/<id>/),
 * the link the add-on copies (…?query=asset_base_id:<id>), a search address.
 * The helper only accepts the bare id, so the page digs it out first and shows
 * what it found before anything is downloaded.
 */

/** An asset base id as BlenderKit mints them: a UUID. */
const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;
/** What the helper accepts as an id (scripts/props/server.js, assign). */
const BARE_ID = /^[A-Za-z0-9-]{8,64}$/;

export function extractAssetId(text: string): string | null {
  const t = text.trim();
  if (!t) return null;
  const tagged = /asset_base_id:\s*([A-Za-z0-9-]{8,64})/i.exec(t);
  if (tagged) return tagged[1];
  const uuid = UUID.exec(t);
  if (uuid) return uuid[0].toLowerCase();
  // Not an address, and shaped like an id: taken as typed.
  return BARE_ID.test(t) ? t : null;
}
